import React, { useState } from "react";
import { Grid, TextField, InputAdornment, Button } from "@mui/material";
import { Search, Add } from "@mui/icons-material";
import DeviceCreate from "./DeviceCreate";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hoc/AuthProvider/useAuth";
import { Permissions } from "../../config/permissions";

interface DeviceFilterProps {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  searchText: string;
  onSearchChange: (value: string) => void;
  loadDevices: () => void;
}

const DeviceFilter: React.FC<DeviceFilterProps> = ({
  setPage,
  searchText,
  onSearchChange,
  loadDevices,
}) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const navigate = useNavigate();
  const { havePermission } = useAuth();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };



  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, sm: "auto" }}>
          <TextField
            fullWidth
            placeholder={"Cihaz ara"}
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {havePermission(Permissions.Device_Create) && (
          <Grid size={{ xs: 12, sm: "auto" }} container alignItems="center" sx={{ gap: 1 }}>
            <Button
              size="medium"
              variant="contained"
              startIcon={<Add />}
              onClick={() => setisModalOpen(true)}
              sx={{
                backgroundColor: "var(--color-primary)",
                "&:hover": { backgroundColor: "var(--color-primary-dark)" },
                textTransform: "none",
                borderRadius: "6px",
              }}
            >
              Cihaz Ekle
            </Button>
          </Grid>
        )}
      </Grid>
      <DeviceCreate
        onClose={() => setisModalOpen(false)}
        open={isModalOpen}
        onSuccess={() => {
          setisModalOpen(false);
          setPage(0);
          loadDevices();
        }}
      />
    </>
  );
};

export default DeviceFilter;
